import * as React from 'react';
export const SvgAlarmEarlyWarning = (props) => {
    return (React.createElement("svg", { viewBox: '0 0 16 16', ...props },
        React.createElement("circle", { cx: 8, cy: 8, fill: '#0ff', r: 6.5 }),
        React.createElement("path", { d: 'M8 2a6 6 0 11-6 6 6.007 6.007 0 016-6m0-1a7 7 0 107 7 7 7 0 00-7-7zm1 11H7v-2h2zm0-8H7v4.667h2z' })));
};
export default SvgAlarmEarlyWarning;
